export const mutations = {
  UPDATE_APPLICATION (state, payload) {
    state = Object.assign(state, payload);
  },
  UPDATE_ADDITIONAL_POSTCODE_FIELDS (state) {
    state.ua_tradingaddresspostcode = state.ua_tradingpostcode;
    state.ua_registeredaddresspostcode = state.ua_registeredpostcode;
  },
  UPDATE_CURRENT_STEP (state, payload) {
    state.ua_currentpageinapplication = payload;
  }
};
